import React from 'react';
import Markdown from '../markdown/Markdown';
import * as styles from './Intro.style';

export type IntroProps = React.PropsWithChildren<{
  title: string,
  description: string,
  rightSlot?: React.ReactNode,
}>;

const Intro: React.FC<IntroProps> = ({
  title,
  description,
  rightSlot,
  children,
}) => (
  <div>
    <h1 css={styles.title}>
      <Markdown>{title}</Markdown>
    </h1>
    <div css={styles.content}>
      <div
        css={styles.intro}
        $hasRightSlot={!!rightSlot}
      >
        <div css={styles.description}>
          <Markdown>
            {description}
          </Markdown>
        </div>
        {children && (
          <div css={styles.children}>
            {children}
          </div>
        )}
      </div>
      {rightSlot && (
        <div css={styles.rightSlot}>
          {rightSlot}
        </div>
      )}
    </div>
  </div>
);

export default Intro;
